<template>
  <div class="sidebar-logo-container pointer" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">

      <div class="userInfo flex pointer" @click="$emit('userShowModal')">
        <img v-if="userInfo.avatar&&userInfo.avatar!=''" :src="userInfo.avatar" alt="">
        <img v-else src="../../../static/daoshi.png" alt="">
        <div class="userName ">
          <div class="flex">
            <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; max-width:120px;">{{ userInfo.name }}</div>
            <i class="el-icon-arrow-right" style="margin-left: 3px;" />
          </div>
          <div class="grade" style="transform: scale(0.9);margin-left: -3px;">编号:{{ userInfo.id }} </div>
        </div>
      </div>

    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    userInfo: {
      type: Object,
      required: true
    },
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: '知视猫',
      logo: 'https://file.jinglinshe.com/zhishimao_logo2.png'
    }
  },
  mounted() {
    // this.getByMobile()
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .sidebarLogoFade-enter-active {
    transition: opacity 1.5s;
  }

  .sidebarLogoFade-enter,
  .sidebarLogoFade-leave-to {
    opacity: 0;
  }

  .userInfo {
    padding-top: 15px;
    height: 95px;

    .flex {
      align-items: center;
    }

    padding: 16px 20px;

    .grade {
      color: rgba(42, 106, 255, 1);
      font-size: 12px;
      line-height: 1;
    }

    .userName {
      // margin-top: 11px;
      line-height: 26px;
      font-size: 12px;
      font-weight: 500;
      color: #161823;

      i {
        font-size: 12px;
        color: #B9B7B7;
      }
    }

    img {
      margin-right: 8px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }

    .grade {
      font-size: 12px;
      /*width: 60px;*/
      height: 22px;
      line-height: 22px;
      border-radius: 3px;
      background-color: rgba(238, 245, 252, 1);
    }
  }

  .sidebar-logo-container {
    position: relative;
    width: 100%;
    height: 100px;
    background: #fff;
    text-align: center;
    overflow: hidden;
    padding-top: 0px;

    & .sidebar-logo-link {
      height: 100%;
      width: 100%;

      & .sidebar-logo {
        width: 50px;
        height: 50px;
        margin-left: -67px;
        vertical-align: middle;

      }

      & .sidebar-title {
        display: inline-block;
        margin: 0;
        color: #fff;
        font-weight: 600;
        line-height: 50px;
        font-size: 14px;
        font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
        vertical-align: middle;
      }
    }

    &.collapse {
      .sidebar-logo {
        margin-right: 0px;
      }
    }
  }
</style>
